import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const TRUCKCATEGORY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.TruckCategory.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.TruckCategory.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const TRUCKCATEGORY_CONFIG = {
  entityName: 'TruckCategory',
  localizationKey: 'General::Entity.TruckCategory',
  fields: TRUCKCATEGORY_FIELDS,
  permission: 'ControllingStructural.TruckCategories',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
